import { useOutletContext } from "react-router-dom";
import PaymentFailed from "../../shared/PaymentFailed";

const PRPaymentFailed = () => {
  const { merchant, reference, id, flowId } = useOutletContext();

  return (
    <PaymentFailed
      merchant={merchant}
      reference={reference}
      retryUrl={`/${flowId}/${id}`}
    />
  );
};

export default PRPaymentFailed;
